import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card, CardContent, CardTitle } from '@/components/ui/card';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: React.ElementType;
  trend?: {
    value: number;
    isPositive: boolean;
  } | null;
}

export const MetricCard: React.FC<MetricCardProps> = ({ title, value, icon: Icon, trend }) => (
  <Card className="bg-white border border-gray-200">
    <CardContent className="pt-6">
      <div className="flex justify-between items-center mb-2">
        <CardTitle className="text-sm font-medium text-gray-600">{title}</CardTitle>
        <Icon className="w-4 h-4 text-black" />
      </div>
      <div className="flex justify-between items-end">
        <div className="text-2xl font-bold">{value}</div>
        {trend && (
          <div className={`flex items-center text-sm ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`}>
            {trend.isPositive ? <TrendingUp className="w-4 h-4 mr-1" /> : <TrendingDown className="w-4 h-4 mr-1" />}
            {trend.value}%
          </div>
        )}
      </div>
    </CardContent>
  </Card>
);
